import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import {
    Box,
    CircularProgress
} from '@mui/material';
import { initializeDB } from '../../config/db';
import { JHA_STORE } from '../../config/constants';

export default function JhaViewer() {
    const { id } = useParams();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        loadJhaData();
    }, [id]);

    async function loadJhaData() {
        try {
            setLoading(true);
            const db = await initializeDB();
            const tx = db.transaction(JHA_STORE, 'readonly');
            const store = tx.objectStore(JHA_STORE);
            
            // Try to get JHA with string ID first
            let jha = await store.get(id);
            
            // If not found and ID is string, try parsing as number
            if (!jha && typeof id === 'string') {
                const numId = parseInt(id);
                if (!isNaN(numId)) {
                    jha = await store.get(numId);
                }
            }
            
            // If not found and ID is number, try as string
            if (!jha && typeof id === 'number') {
                jha = await store.get(String(id));
            }

            if (jha) {
                // Navigate to step 1 with JHA data and viewMode flag
                navigate('/jha/step-1', { 
                    state: { 
                        isNew: false, 
                        jha: jha,
                        viewMode: true,
                        fromViewer: true
                    } 
                });
            } else {
                console.error('JHA not found with ID:', id, 'Type:', typeof id);
                navigate('/jha');
            }
        } catch (error) {
            console.error('Error loading JHA:', error);
            navigate('/jha');
        }
    }

    if (loading) {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center', p: 4 }}>
                <CircularProgress />
            </Box>
        );
    }

    return null;
}